export const IDS = {
  // Login
  loginPage: "login-page",
  loginUsername: "login-username",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",

  // Layout
  sidebarDashboard: "sidebar-dashboard",
  sidebarNewOrder: "sidebar-new-order",
  sidebarCurrent: "sidebar-current-orders",
  sidebarSent: "sidebar-sent-orders",
  sidebarInventory: "sidebar-inventory",
  sidebarSettings: "sidebar-settings",
  headerLogout: "header-logout",

  // Dashboard
  dashboardPage: "dashboard-page",
  statCurrent: "stat-current-orders",
  statSent: "stat-sent-orders",
  statInventory: "stat-inventory-items",
  statTotalValue: "stat-total-value",

  // Orders list
  ordersList: "orders-list",
  orderRowPrefix: "order-row-",
  createOrderBtn: "create-order-btn",

  // Order Editor
  editorPage: "order-editor-page",
  editorOrderNo: "editor-order-no",
  editorSearchInput: "editor-search-input",
  editorSearchBtn: "editor-search-btn",
  editorSearchResult: "editor-search-result",
  editorAddPartBtn: "editor-add-part-btn",
  editorItemsTable: "editor-items-table",
  editorRemarks: "editor-remarks",
  editorSaveBtn: "editor-save-btn",
  editorMarkSentBtn: "editor-mark-sent-btn",
  editorReopenBtn: "editor-reopen-btn",
  editorExcelBtn: "editor-excel-btn",
  editorPdfBtn: "editor-pdf-btn",
  editorDeleteBtn: "editor-delete-btn",
  editorDuplicateWarning: "editor-duplicate-warning",
  editorPreviousWarning: "editor-previous-warning",

  // Settings
  settingsPage: "settings-page",
  settingsDiscount: "settings-discount",
  settingsSaveDiscount: "settings-save-discount",

  // Inventory
  inventoryPage: "inventory-page",
  inventoryFileInput: "inventory-file-input",
  inventoryPreviewBtn: "inventory-preview-btn",
  inventoryMappingPartNo: "inventory-mapping-part-no",
  inventoryMappingQty: "inventory-mapping-stock-qty",
  inventoryMappingDesc: "inventory-mapping-description",
  inventoryMappingLoc: "inventory-mapping-location",
  inventoryMappingRate: "inventory-mapping-rate",
  inventoryUploadBtn: "inventory-upload-btn",
  inventorySearch: "inventory-search",
  inventoryTable: "inventory-table",

  // Inventory lock
  inventoryLockBanner: "inventory-lock-banner",
  inventoryLockOverlay: "inventory-lock-overlay",
  inventoryLockUploadBtn: "inventory-lock-upload-btn",
  inventoryFreshBadge: "inventory-fresh-badge",

  // Important parts
  sidebarImportant: "sidebar-important-parts",
  importantPage: "important-parts-page",
  importantPartNo: "important-part-no",
  importantDesc: "important-desc",
  importantThreshold: "important-threshold",
  importantAddBtn: "important-add-btn",
  importantTable: "important-parts-table",
  lowStockCard: "dashboard-low-stock-card",

  // Mandatory parts
  sidebarMandatory: "sidebar-mandatory-parts",
  mandatoryPage: "mandatory-parts-page",
  mandatoryToggle: "mandatory-toggle",
  mandatoryPartNo: "mandatory-part-no",
  mandatoryDesc: "mandatory-desc",
  mandatoryMrp: "mandatory-mrp",
  mandatoryQty: "mandatory-qty",
  mandatoryAddBtn: "mandatory-add-btn",
  mandatoryTable: "mandatory-parts-table",
};
